<template>
    <div>
		<div class="table_description table_description_filter" id="custom_rating_table_description">
			<div class="tertiary_color text_left">
				{{ $t("customRating.table.headTip") }}
			</div>
		</div>
		<div class="table_head table_head_filter">
			<div class="flex flex_between">
				<md-button class="md-primary margin_r" @click="showAddCompanyModal()">
					{{ $t("customRating.table.addCompany") }}
				</md-button>
				<md-button class="md-blank margin_r" @click="showDisplaySettingModal(true)">
					<i class="fa fa-cogs btn_icon" aria-hidden="true"></i>
					{{ $t("customRating.table.manageRiskAssessment") }}
				</md-button>
			</div>
		</div>
		<template v-if="config">
			<div class="flex filter_table">
				<div class="flex flex_column w_100">
					<CustomRatingTable :filters="filters" :config="config" ref="table"/>
				</div>
				<CustomRatingFilter :config="config" @apply-filter="applyFilter"/>
			</div>
			<CustomRatingDisplaySettingModal v-if="displaySettingModalShown"
											 :config="config"
											 @close="showDisplaySettingModal(false)"
											 @submit="confirmSubmitDisplaySetting"
			/>
		</template>
    </div>
</template>

<script>
import CustomRatingTable from "@/components/templates/investor/riskAssessment/customRatings/CustomRatingTable.vue";
import CustomRatingFilter from "@/components/templates/investor/riskAssessment/customRatings/CustomRatingFilter.vue";
import CustomRatingDisplaySettingModal
	from "@/components/templates/investor/riskAssessment/customRatings/CustomRatingManageRiskAssessmentModal.vue";
import {customRatingsApi} from "@/common/api/customRatingsApi";
import {isValueSet} from "@/common/format";

export default {
	components: {
		CustomRatingDisplaySettingModal,
		CustomRatingFilter,
		CustomRatingTable
	},
	data() {
		return {
			filters: [],
			displaySettingModalShown: false,
			defaultConfig: {
				showRating1: null,
				showRating2: null,
				showRating3: null,
				nameRating1: this.$t("customRating.table.rating1"),
				nameRating2: this.$t("customRating.table.rating2"),
				nameRating3: this.$t("customRating.table.rating3"),
			},
			config: null
		};
	},
	created() {
		this.loadConfig();
	},
	methods: {
		loadConfig() {
			customRatingsApi.inspection.getConfig()
				.then(this.updateConfig)
				.catch(this.toast);
		},
		updateConfig(newConfig) {
			this.config = {
				...newConfig,
				nameRating1OrDefault: isValueSet(newConfig.nameRating1) ? newConfig.nameRating1 : this.defaultConfig.nameRating1,
				nameRating2OrDefault: isValueSet(newConfig.nameRating2) ? newConfig.nameRating2 : this.defaultConfig.nameRating2,
				nameRating3OrDefault: isValueSet(newConfig.nameRating3) ? newConfig.nameRating3 : this.defaultConfig.nameRating3
			};
		},
		applyFilter(filters) {
			this.filters = filters;
		},
		showDisplaySettingModal(show) {
			this.displaySettingModalShown = show;
		},
		showAddCompanyModal() {
			this.$refs.table.showEditModal(null);
		},
		confirmSubmitDisplaySetting(data) {
			let option = {
				msg: this.$t("customRating.table.manageRiskAssessment.confirm.msg"),
				confirmFun: this.submitDisplaySetting,
				params: data
			};
			this.confirmMeg(option, true);
		},
		submitDisplaySetting(data) {
			customRatingsApi.operation.saveConfig(data)
				.then(() => {
					this.updateConfig(data);
					this.showDisplaySettingModal(false);
					this.toastSuccess();
				})
				.catch(this.toast);
		}
	}
}
</script>